import cx from 'classnames';
import React, { PropsWithChildren } from 'react';
import Modal from 'react-modal';

import overlayStyle from '../Overlay/overlay.module.css';

import s from './modal.module.css';

export interface ModalProps {
    className?: string;
    isOpen: boolean;
    mainButton: JSX.Element;
    onRequestClose?: () => void;
    overlayClassName?: string;
    secondaryButton?: JSX.Element;
    title: string;
}

const CustomModal = ({
    children,
    className,
    mainButton,
    overlayClassName,
    secondaryButton,
    title,
    ...props
}: PropsWithChildren<ModalProps>) => (
    <Modal
        {...props}
        ariaHideApp={false}
        className={cx(s.modalContainer, className)}
        overlayClassName={cx(overlayStyle.overlay, overlayStyle.visible, overlayClassName)}
    >
        <h2>{title}</h2>
        {children}
        <div className={s.modalButtons}>
            {secondaryButton}
            {mainButton}
        </div>
    </Modal>
);

CustomModal.displayName = 'Modal';

export default CustomModal;
